<template>
  <v-container class='registroPage'>
    <h1 class='registroTitle'>Registro</h1>
    <v-card class='registroForm'>
      <v-card-title class='formTitle'>Por favor, ingrese sus datos</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col lg='4' md='6' sm='8' cols='12'>
              <v-text-field
                v-for='fieldName in ["nombres"]'
                v-model='formFields[fieldName].value'
                :label='fieldLabel(formFields[fieldName])'
                outlined
                @focus='onFocus($event, fieldName)'
                @keydown='onKeyDown($event, fieldName)'
                @input='onInput($event, fieldName)'
                @blur='onBlur($event, fieldName)'
                :key='formFields[fieldName].key'
                :ref='fieldName'
              ></v-text-field>
            </v-col>
            <v-col lg='4' md='6' sm='8' cols='12'>
              <v-text-field
                v-for='fieldName in ["apellidoPaterno"]'
                v-model='formFields[fieldName].value'
                :label='fieldLabel(formFields[fieldName])'
                outlined
                @focus='onFocus($event, fieldName)'
                @keydown='onKeyDown($event, fieldName)'
                @input='onInput($event, fieldName)'
                @blur='onBlur($event, fieldName)'
                :key='formFields[fieldName].key'
                :ref='fieldName'
              ></v-text-field>
            </v-col>
            <v-col lg='4' md='6' sm='8' cols='12'>
              <v-text-field
                v-for='fieldName in ["apellidoMaterno"]'
                v-model='formFields[fieldName].value'
                :label='fieldLabel(formFields[fieldName])'
                outlined
                @focus='onFocus($event, fieldName)'
                @keydown='onKeyDown($event, fieldName)'
                @input='onInput($event, fieldName)'
                @blur='onBlur($event, fieldName)'
                :key='formFields[fieldName].key'
                :ref='fieldName'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg='5' md='5' sm='8' cols='12'>
              <v-text-field
                v-for='fieldName in ["email"]'
                v-model='formFields[fieldName].value'
                :label='fieldLabel(formFields[fieldName])'
                outlined
                @focus='onFocus($event, fieldName)'
                @keydown='onKeyDown($event, fieldName)'
                @input='onInput($event, fieldName)'
                @blur='onBlur($event, fieldName)'
                :key='formFields[fieldName].key'
                :ref='fieldName'
              ></v-text-field>
            </v-col>
            <v-col lg='4' md='4' sm='8' cols='12'>
              <v-text-field
                v-for='fieldName in ["telefono"]'
                v-model='formFields[fieldName].value'
                :label='fieldLabel(formFields[fieldName])'
                outlined
                @focus='onFocus($event, fieldName)'
                @keydown='onKeyDown($event, fieldName)'
                @input='onInput($event, fieldName)'
                @blur='onBlur($event, fieldName)'
                :key='formFields[fieldName].key'
                :ref='fieldName'
              ></v-text-field>
            </v-col>
            <v-col lg='3' md='3' sm='8' cols='12'>
              <v-text-field
                v-for='fieldName in ["rfc"]'
                v-model='formFields[fieldName].value'
                :label='fieldLabel(formFields[fieldName])'
                outlined
                @focus='onFocus($event, fieldName)'
                @keydown='onKeyDown($event, fieldName)'
                @input='onInput($event, fieldName)'
                @blur='onBlur($event, fieldName)'
                :key='formFields[fieldName].key'
                :ref='fieldName'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols='12'>
              <v-text-field
                v-for='fieldName in ["empresa"]'
                v-model='formFields[fieldName].value'
                :label='fieldLabel(formFields[fieldName])'
                outlined
                @focus='onFocus($event, fieldName)'
                @keydown='onKeyDown($event, fieldName)'
                @input='onInput($event, fieldName)'
                @blur='onBlur($event, fieldName)'
                :key='formFields[fieldName].key'
                :ref='fieldName'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col lg='6' md='6' sm='8' cols='12'>
              <v-text-field
                v-for='fieldName in ["username"]'
                v-model='formFields[fieldName].value'
                :label='fieldLabel(formFields[fieldName])'
                outlined
                @focus='onFocus($event, fieldName)'
                @keydown='onKeyDown($event, fieldName)'
                @input='onInput($event, fieldName)'
                @blur='onBlur($event, fieldName)'
                :key='formFields[fieldName].key'
                :ref='fieldName'
              ></v-text-field>
            </v-col>
            <v-col lg='6' md='6' sm='8' cols='12'>
              <v-text-field
                v-for='fieldName in ["serverName"]'
                v-model='formFields[fieldName].value'
                :label='fieldLabel(formFields[fieldName])'
                outlined
                @focus='onFocus($event, fieldName)'
                @keydown='onKeyDown($event, fieldName)'
                @input='onInput($event, fieldName)'
                @blur='onBlur($event, fieldName)'
                :key='formFields[fieldName].key'
                :ref='fieldName'
                disabled
                placeholder='Característica premium'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg='4' md='6' sm='8' cols='12'>
              <v-container>
                <v-row>
                  <v-text-field
                    v-for='fieldName in ["password"]'
                    v-model='formFields[fieldName].value'
                    :label='fieldLabel(formFields[fieldName])'
                    outlined
                    @focus='onFocus($event, fieldName)'
                    @keydown='onKeyDown($event, fieldName)'
                    @input='onInput($event, fieldName)'
                    @blur='onBlur($event, fieldName)'
                    :key='formFields[fieldName].key'
                    :ref='fieldName'
                    :hint='passwordLengthMessage'
                    :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPass ? 'text' : 'password'"
                    @click:append="showPass = !showPass"
                  ></v-text-field>
                </v-row>
                <v-row>
                  <v-text-field
                    v-for='fieldName in ["confirmPassword"]'
                    v-model='formFields[fieldName].value'
                    :label='fieldLabel(formFields[fieldName])'
                    outlined
                    @focus='onFocus($event, fieldName)'
                    @keydown='onKeyDown($event, fieldName)'
                    @input='onInput($event, fieldName)'
                    @blur='onBlur($event, fieldName)'
                    :key='formFields[fieldName].key'
                    :ref='fieldName'
                    :persistent-hint='true'
                    hint=' '
                    :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showConfirm ? 'text' : 'password'"
                    @click:append="showConfirm = !showConfirm"
                  ></v-text-field>
                </v-row>
              </v-container>
            </v-col>
            <v-col lg='8' md='6' sm='12' cols='12'>
              <v-list dense>
                <v-list-item v-for='c in passwordConstraints' :key='c'>
                  <v-list-item-icon><v-icon v-text='passMsgIcon(c)' :color='passMsgColor(c)'></v-icon></v-list-item-icon>
                  <v-list-item-subtitle v-text='passMsgLine(c)' style='white-space: initial;'></v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col lg='10' md='9' sm='8' cols='7'>
            <v-textarea
              :value='requiredFieldsMessage'
              readonly
              rows='1'
              no-resize
              auto-grow
              :class='"msg " + (formError ? "err" : "norm")'
              solo
              flat
            ></v-textarea>
          </v-col>
          <v-col lg='2' md='3' sm='4' smcols='5'>
            <v-btn class='formBtn' color='primary' @click="submitForm" :disabled='awaitingResponse'>Enviar</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import { ApiInit } from '@/api';
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
  import { removeWhitespace, isEmptyVariable } from '@/utils/checkQuery.js';

  export default {
    data() {
      return {
        formFields: {
          nombres: { value: '', type: 'text', message: 'Nombre inválido', altName: 'nombres', key: 0, required: true },
          apellidoPaterno: { value: '', type: 'text', message: 'Apellido paterno inválido', altName: 'apellido paterno', key: 0, required: true },
          apellidoMaterno: { value: '', type: 'text', message: 'Apellido materno inválido', altName: 'apellido materno', key: 0, required: false },
          email: { value: '', type: 'email', message: 'Correo inválido', altName: 'correo electrónico', key: 0, required: true },
          telefono: { value: '', type: 'phone', message: 'Número telefónico inválido', altName: 'teléfono', key: 0, required: true },
          rfc: { value: '', type: 'rfc', message: 'RFC inválido', altName: 'RFC', key: 0, required: false },
          empresa: { value: '', type: 'text', message: 'Nombre de empresa inválido', altName: 'empresa', key: 0, required: false },
          username: { value: '', type: 'username', message: 'Nombre de usuario inválido', altName: 'nombre de usuario', key: 0, required: true },
          serverName: { value: '', type: 'domain', message: 'Nombre del dominio inválido', altName: 'nombre del dominio', key: 0, required: false },
          password: { value: '', type: 'password', message: 'Contraseña inválida', altName: 'contraseña', key: 0, required: true },
          confirmPassword: { value: '', type: 'cpassword', message: 'Contraseña inválida', altName: 'confirmación de la contraseña', key: 0, required: true },
        },
        formError: false,
        awaitingResponse: false,
        inputBuffer: '',
        nameBuffer: '',
        cursorPositionBuffer: 0,
        changeValue: false,
        passwordConstraints: ['title', 'length', 'required', 'optional'],
        showPass: false,
        showConfirm: false,
      }
    },
    computed: {
      countRequiredFields() {
        let count = 0;
        for (const fieldName in this.formFields) {
          const field = this.formFields[fieldName];
          if (field.required) count++;
        }
        return count;
      },
      requiredFieldsMessage() {
        if (!this.formError) return '*Campos obligatorios.';
        const n = this.countRequiredFields;
        if (n === 0) return '';
        let msg = '*Los campos de ';
        let index = 0;
        for (const fieldName in this.formFields) {
          const field = this.formFields[fieldName];
          if (!field.required) continue;
          index++;
          if (n === 1) return `*El campo de ${field.altName} es obligatorio.`;
          msg += field.altName;
          if (index < n-1) msg += ', ';
          if (index === n-1) msg += ' y ';
          if (index === n) msg += ' son obligatorios.';
        }
        return msg;
      },
      passwordStrength() {
        const password = this.formFields.password.value;
        let strength = 0;
        if (/[a-z]+/.test(password)) strength++;
        if (/[A-Z]+/.test(password)) strength++;
        if (/\d+/.test(password)) strength++;
        return strength;
      },
      passLength() {
        return this.formFields.password.value.length;
      },
      passLong() {
        if (this.passLength >= 8) return true;
        return false;
      },
      passwordLengthMessage() {
        const n = this.formFields.password.value.length;
        return `Longitud actual: ${n} caracter${ n === 1 ? '' : 'es' }`;
      },
      showPassMsgErr() {
        if (this.formFields.confirmPassword.value.length === 0) return false;
        if (this.samePasswords(false)) return false;
        else return true;
      },
      passMsg() {
        if (this.showPassMsgErr) return 'Las contraseñas no coinciden';
        else return '';
      },
      passwordHasSpecialCharacters() {
        if (!/^(?=.*[.,@$!%*#?&]).*$/.test(this.formFields.password.value)) return false;
        return true;
      },
      nombreCompleto() {
        return this.formFields.nombres.value + ' ' + this.formFields.apellidoPaterno.value + ' ' + this.formFields.apellidoMaterno.value;
      },
      nombreCorto() {
        return removeWhitespace(this.formFields.nombres.value);
      },
      fieldValues() {
        let values = {};
        for (const fieldName in this.formFields) values[fieldName] = this.formFields[fieldName].value;
        return values;
      },
      request() {
        const fields = this.fieldValues;
        let request = {
          cliente: {
            creationUsername: fields.username,
            email: fields.email,
            empresa: fields.empresa,
            id: 0,
            lastModificationUsername: fields.username,
            nombre: this.nombreCompleto,
            rfc: fields.rfc,
            serverName: fields.serverName,
            telefono: fields.telefono,
          },
          usuario: {
            accountNonExpired: true,
            accountNonLocked: true,
            altEmail: fields.email,
            comments: '',
            creationUsername: fields.username,
            credentialsNonExpired: true,
            enabled: false,
            id: 0,
            lastModificationUsername: fields.username,
            lastName: fields.apellidoPaterno,
            name: this.nombreCompleto,
            password: fields.password,
            phoneNumber: fields.telefono,
            roles: [
              'admin',
              'user',
              'prueba',
            ],
            secondLastName: fields.apellidoMaterno,
            shortName: this.nombreCorto,
            username: fields.username,
          },
          contacto: {
            nombre: this.nombreCompleto,
            correo: fields.email,
            sms: fields.telefono,
            razonSocial: fields.empresa,
            rfc: fields.rfc,
          },
        };
        return request;
      },
    },
    mounted() {
      ApiInit();
    },
    methods: {
      async submitForm() {
        this.formFields.rfc.value = this.formFields.rfc.value.toUpperCase();
        if (!(await this.validateForm())) {
          this.formError = true;
          return;
        }
        const defaultToastMessage = 'Error al hacer el registro.';
        const defaultConsoleMessage = 'submitForm error';
        try {
          const request = this.request;
          this.awaitingResponse = true;
          const response = await this.$store.dispatch('registrarCliente', {request});
          if (response === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          this.$toast.success(`<h2>Se le ha enviado un correo a ${this.formFields.email.value} para que confirme su registro.</h2>`);
          let self = this;
          window.setTimeout((obj) => (obj.$router.push({name:'Login'})), 2000, self)
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
          this.stopWait();
        }
      },
      async validateForm() {
        for (const fieldName in this.formFields) {
          const field = this.formFields[fieldName];
          if (!field.required) continue;
          if (!(await this.isValidField(fieldName))) return false;
        }
        if (!this.samePasswords()) return false;
        return true;
      },
      async isValidField(fieldName, showToast = true) {
        const field = this.formFields[fieldName];
        const value = field.value;
        let type = field.type;
        if (typeof value !== 'string' || isEmptyVariable(value)) type = 'empty';
        const altName = field.altName;
        let message = field.message;
        let cMessage = `isValidField(): invalid field "${fieldName}" with value "${value}"`;
        let isValid = true;
        switch (type) {
          case 'empty':
          isValid = false;
          message = `Falta el campo de ${altName}`;
          break;

          case 'text':
          break;

          case 'email':
          if (!/^[\w-]+(\.[\w-]+)*@(\w([\w-]+\w)*)+(\.(\w([\w-]+\w)*)+)*(\.\w{2,3})+$/.test(value)) isValid = false;
          break;

          case 'phone':
          if (!/^\+{0,1}[\d]{10,20}$/.test(removeWhitespace(value).replace(/\-/g, ''))) isValid = false;
          break;

          case 'rfc':
          try {
            const rfc = value;
            const response = await this.$store.dispatch('RFCValid', {rfc});
            if (response === null) {
              isValid = false;
              message = 'Error al validar el RFC.';
              cMessage = `isValidField(): field "${fieldName}", /rfc/check/${value}: undefined response`;
              break;
            }
            isValid = response
          } catch (e) {
            consoleErrorMessage(e, cMessage);
            if (showToast) toasterErrorMessage(this.$toast.error, e, message);
            return false;
          }
          break;

          case 'username':
          if (!/(^[\w-]+(\.[\w-]+)*@(\w([\w-]+\w)*)+(\.(\w([\w-]+\w)*)+)*(\.\w{2,3})+$)|(^[\w-. ]+$)/.test(value)) isValid = false;
          break;

          case 'password':
          if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d.,@$!%*#?&]{8,}$/.test(value)) isValid = false;
          break;

          case 'cpassword':
          break;

          case 'domain':
          break;

          default:
          isValid = false;
          cMessage = `isValidField(): unknown field type "${type}" for field "${fieldName}"`;
          message = `Error de validación de ${altName}`;
        }
        if (!isValid) {
          if (showToast) this.$toast.error(message);
          console.error(cMessage);
          return false;
        }
        return true;
      },
      onFocus(event, fieldName) {
        const field = this.formFields[fieldName];
        this.inputBuffer = field.value;
        this.nameBuffer = fieldName;
      },
      onKeyDown(event, fieldName) {
        const field = this.formFields[fieldName];
        this.inputBuffer = field.value;
        if (event.key.length > 1) return;
        let prevent = false;
        switch (field.type) {
          case 'email':
          if (!/^[\w-.@]$/.test(event.key)) prevent = true;
          break;

          case 'phone':
          if (!/^[+-\d cv]$/.test(event.key)) prevent = true;
          break;

          case 'rfc':
          if (!/^[A-Za-z\dñÑ&]$/.test(event.key)) prevent = true;
          break;

          case 'username':
          if (!/^[\w-.@ ]$/.test(event.key)) prevent = true;
          break;

          case 'cpassword':
          case 'password':
          if (!/^[A-Za-z\d.,@$!%*#?&]$/.test(event.key)) prevent = true;
          break;
        }
        if (prevent) event.preventDefault();
      },
      onInput(event, fieldName) {
        const field = this.formFields[fieldName];
        this.changeValue = false;
        switch (field.type) {
          case 'email':
          if (!/^[\w-.]*@{0,1}[\w-.]*$/.test(field.value)) this.changeValue = true;
          break;

          case 'phone':
          if (!/^\+{0,1}(\d+\-{0,1})*$/.test(removeWhitespace(field.value))) this.changeValue = true;
          break;

          case 'rfc':
          if (!/^[A-Za-z\dñÑ&]{0,13}$/.test(field.value)) this.changeValue = true;
          break;

          case 'username':
          if (!/(^[\w-.]*@{0,1}[\w-.]*$)|(^[\w-. ]*$)/.test(field.value)) this.changeValue = true;
          break;

          case 'cpassword':
          case 'password':
          if (!/^[A-Za-z\d.,@$!%*#?&]*$/.test(field.value)) this.changeValue = true;
          break;
        }
        if (this.changeValue) {
          const diff = field.value.length - this.inputBuffer.length;
          this.cursorPositionBuffer = this.$refs[fieldName][0].$refs.input.selectionEnd - diff;
          field.value = this.inputBuffer;
          field.key++;
        }
      },
      onBlur(event, fieldName) {
        this.nameBuffer = '';
        const field = this.formFields[fieldName];
        switch (field.type) {
          case 'rfc':
          field.value = field.value.toUpperCase();
          break;
        }
      },
      fieldLabel(field) {
        let label = '';
        if (field.required) label += '*';
        label += field.altName[0].toUpperCase() + field.altName.substring(1);
        return label;
      },
      stopWait() {
        var self = this;
        window.setTimeout((obj) => { obj.awaitingResponse = false; }, 500, self);
      },
      passMsgLine(name) {
        switch (name) {
          case 'title':
          if (this.passwordStrength + (this.passLong ? 1 : 0) >= 4) return 'Contraseña válida:';
          return 'Contraseña inválida:';
          
          case 'length':
          if (this.passLong) return 'Contiene al menos 8 caracteres';
          return 'Debe contener al menos 8 caracteres';
          
          case 'required':
          if (this.passwordStrength >= 3) return 'Contiene al menos una minúscula, una mayúscula y un número';
          return 'Debe contener al menos una minúscula, una mayúscula y un número';
          
          case 'allowed':
          return 'Puede contener caracteres alfanuméricos';
          
          case 'optional':
          if (this.passwordHasSpecialCharacters) return 'Contiene caracteres especiales .,@$!%*#?&`';
          return 'Puede contener los caracteres especiales .,@$!%*#?&`';
          
          default:
          return '';
        }
      },
      passMsgIcon(name) {
        let score = this.passwordStrength;
        let target = 3;
        switch (name) {
          case 'allowed':
          return 'mdi-alphabetical';
          
          case 'optional':
          return 'mdi-symbol';
          
          case 'length':
          if (this.passLong) return 'mdi-check';
          break;

          case 'title':
          score += (this.passLong ? 1 : 0);
          target++;
          case 'required':
          if (score >= target) return 'mdi-check';
          break;

          default:
          return '';
        }
        return 'mdi-minus';
      },
      passMsgColor(name) {
        let score = this.passwordStrength;
        let target = 3;
        switch (name) {
          case 'allowed':
          case 'optional':
          if (this.passwordHasSpecialCharacters) return 'blue';
          return 'grey';
          
          case 'length':
          if (this.passLength >= 8) return 'green';
          if (this.passLength > 0) return 'yellow';
          break;

          case 'title':
          score += (this.passLong ? 1 : 0);
          target++;
          case 'required':
          if (score > 0 && score < target) return 'yellow';
          if (score >= target) return 'green';
          break;

          default:
          return 'grey';
        }
        return 'red';
      },
      samePasswords(showToast = true) {
        if (this.formFields.password.value === this.formFields.confirmPassword.value) return true;
        if (showToast) this.$toast.error('Las contraseñas no coinciden.');
        return false;
      },
      setPassMsgError(elem) {
        elem.textContent = this.passMsg;
        if (this.showPassMsgErr) elem.style = 'color: red';
      },
    },
    updated() {
      if (this.nameBuffer.length > 0 && this.changeValue) {
        this.changeValue = false;
        this.$refs[this.nameBuffer][0].focus();
        this.$refs[this.nameBuffer][0].$refs.input.selectionEnd = this.cursorPositionBuffer;
      }
    },
    watch: {
      'formFields.password.value'() {
        const hintElem = this.$refs.confirmPassword[0].$children[1].$el;
        this.setPassMsgError(hintElem);
      },
      'formFields.confirmPassword.value'() {
        const hintElem = this.$refs.confirmPassword[0].$children[1].$el;
        this.setPassMsgError(hintElem);
      },
    },
  };
</script>

<style scoped>
  /* Clase registroPage es para definir el contexto 'scoped' */
  .registroPage {}

  .registroTitle {
    margin: 20px;
  }

  .registroForm {}

  .formTitle {
    margin: 20px;
    padding-top: 30px;
  }

  .formBtn {
    float: right;
    margin-right: 20px;
  }

  .theme--light .msg >>> textarea {
    font-size: 10pt;
    overflow-y: auto;
  }
  .theme--light .err >>> textarea {
    color: red;
  }
  .theme--light .norm >>> textarea {
    color: black;
  }
  .theme--light .gray >>> textarea {
    color: gray;
  }
</style>